export class AxisXY {
  type = "";
  boundaryGap?: boolean;
  data?: any;
  axisLabel?: any;
}

export class OptionsChart {
  title: Record<string, unknown> = {};
  legend?: Record<string, unknown> = {};
  grid?: Record<string, unknown> = {};
  tooltip?: Record<string, unknown> = {};
  xAxis?: AxisXY | AxisXY[] = [];
  yAxis?: AxisXY | AxisXY[] = [];
  series?: any[] = [];
  angleAxis?: Record<string, unknown> = {};
  radiusAxis?: Record<string, unknown> = {};
  polar?: Record<string, unknown> = {};
  color?: string[] = [];
  emphasis?: Record<string, unknown> = {};
}
